import { values } from 'ramda'

import { getStateCurrentValue, getStateItems, type State } from 'app/common/ui-components/filter'

import { filterId } from './filterId'


export const singleBuildingSelected = (state: State) => {
  const buildingIds = getStateCurrentValue(filterId, state)
  return buildingIds.length === 1
}

export const buildingMoreThanOne = (state: State) => {
  const buildingIds = getStateItems(filterId, state)
  return values(buildingIds).length > 1
}
